<template>
  <section id="compare" class="compare">
    <h2>Compare Our Plans</h2>
    <p>See which plan is best for you by comparing the features offered.</p>

    <PricingCompareTable />
  </section>
</template>

<script>
import PricingCompareTable from '@/components/pricing/pricing-compare-table';

export default {
  components: {
    PricingCompareTable,
  },
};
</script>

<style lang="scss" scoped>
.compare {
  padding: 1rem 0;
  text-align: center;

  @media (min-width: 768px) {
    padding: 2rem 0;
  }
}
</style>
